const isShippingMessageExpired = () => {
    const currentDate = new Date()
    const endDate = new Date(Date.UTC(2024, 8, 3, 5, 0, 0)) // September 3, 2024, 05:00 AM UTC
    return currentDate >= endDate
}

const shippingMessage = `In recognition of Labor Day, orders placed on Monday,
    September 2, will be printed and shipped on Tuesday,
    September 3.`

const TemporaryShippingInfo = ({ type }: { type: string }) => {
    if (isShippingMessageExpired()) return null

    return type === 'itemized-shipping-message' ? (
        <ul>
            <li>{shippingMessage}</li>
        </ul>
    ) : (
        <p>{shippingMessage}</p>
    )
}

export default TemporaryShippingInfo
